/**
 * 按钮权限控制工具
 * 用于检查用户是否有权限显示或操作某个按钮
 */

/**
 * 获取登录用户信息（从sessionStorage）
 * @returns {Object} 用户信息对象
 */
export function getLoginUserInfo() {
  const userInfo = sessionStorage.getItem('userInfo')
  return userInfo ? JSON.parse(userInfo) : {}
}

/**
 * 检查用户是否为管理员
 * @returns {Boolean} 是否为管理员
 */
export function isAdmin() {
  const userInfo = getLoginUserInfo()
  return userInfo.isAdmin === true || userInfo.isAdmin === 'true'
}

/**
 * 获取用户拥有的所有按钮编码
 * @returns {Array} 按钮编码数组
 */
export function getUserButtonCodes() {
  const userInfo = getLoginUserInfo()
  const buttonCodes = []

  // 递归函数：遍历菜单树，收集所有按钮编码
  const collectButtonCodes = (menus) => {
    if (!menus || !Array.isArray(menus)) {
      return
    }

    menus.forEach(menu => {
      // 收集当前菜单的按钮
      if (menu.buttons && Array.isArray(menu.buttons)) {
        menu.buttons.forEach(button => {
          if (button.code) {
            buttonCodes.push(button.code)
          }
        })
      }

      // 递归收集子菜单的按钮
      if (menu.children && Array.isArray(menu.children)) {
        collectButtonCodes(menu.children)
      }
    })
  }

  if (userInfo.menuList && Array.isArray(userInfo.menuList)) {
    collectButtonCodes(userInfo.menuList)
  }

  return buttonCodes
}

/**
 * 检查用户是否有权限显示某个按钮
 * @param {String} buttonCode 按钮编码
 * @returns {Boolean} 是否有权限
 */
export function hasButtonPermission(buttonCode) {
  // 管理员拥有所有权限
  if (isAdmin()) {
    return true
  }else{
    console.log('不是管理员')
  }

  // 检查用户是否拥有该按钮权限
  const buttonCodes = getUserButtonCodes()
  console.log("codes===>",buttonCodes);
  return buttonCodes.includes(buttonCode)
}

/**
 * 检查用户是否有权限访问某个菜单
 * @param {String} menuCode 菜单编码
 * @returns {Boolean} 是否有权限
 */
export function hasMenuPermission(menuCode) {
  // 管理员拥有所有权限
  if (isAdmin()) {
    return true
  }

  const userInfo = getLoginUserInfo()
  if (!userInfo.menuList || !Array.isArray(userInfo.menuList)) {
    return false
  }

  // 递归查找菜单
  const findMenu = (menus) => {
    if (!menus || !Array.isArray(menus)) {
      return false
    }

    for (let menu of menus) {
      if (menu.code === menuCode) {
        return true
      }

      // 递归查找子菜单
      if (menu.children && Array.isArray(menu.children)) {
        if (findMenu(menu.children)) {
          return true
        }
      }
    }

    return false
  }

  return findMenu(userInfo.menuList)
}

/**
 * 获取某个菜单下的所有按钮
 * @param {String} menuCode 菜单编码
 * @returns {Array} 按钮数组
 */
export function getMenuButtons(menuCode) {
  const userInfo = getLoginUserInfo()

  if (!userInfo.menuList || !Array.isArray(userInfo.menuList)) {
    return []
  }

  // 递归查找菜单
  const findMenuButtons = (menus) => {
    if (!menus || !Array.isArray(menus)) {
      return null
    }

    for (let menu of menus) {
      if (menu.code === menuCode) {
        return menu.buttons || []
      }

      // 递归查找子菜单
      if (menu.children && Array.isArray(menu.children)) {
        const result = findMenuButtons(menu.children)
        if (result !== null) {
          return result
        }
      }
    }

    return null
  }

  const buttons = findMenuButtons(userInfo.menuList)
  return buttons !== null ? buttons : []
}

/**
 * 批量检查多个按钮权限
 * @param {Array} buttonCodes 按钮编码数组
 * @returns {Object} 权限对象，key为按钮编码，value为是否有权限
 */
export function checkMultipleButtonPermissions(buttonCodes) {
  const permissions = {}
  buttonCodes.forEach(code => {
    permissions[code] = hasButtonPermission(code)
  })
  return permissions
}

export default {
  getLoginUserInfo,
  isAdmin,
  getUserButtonCodes,
  hasButtonPermission,
  hasMenuPermission,
  getMenuButtons,
  checkMultipleButtonPermissions
}
